<template>
  <v-card>
    <v-card-text v-if="token && token.meta.joined !== false">
      <v-row
        justify="center"
        align="center"
        class="mb-10 text-center"
      >
        <span class="black--text display-3">Invitation accepted</span>
      </v-row>
      <template v-if="isLoggedIn">
        <v-btn
          block
          large
          color="primary"
          class="accent--text headline"
          @click="gotoHive()"
        >
          Go to Hub
        </v-btn>
      </template>
      <template v-if="!isLoggedIn">
        <v-btn
          block
          large
          color="primary"
          class="accent--text headline"
          :to="{ name: 'login' }"
        >
          Login now
        </v-btn>
      </template>
    </v-card-text>
    <v-card-text
      v-if="token && token.meta.joined === false"
    >
      <token-finish-auth-card
        :token="token"
      />
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import TokenFinishAuthCard from "./TokenFinishAuthCard"

export default {
  components: { TokenFinishAuthCard },
  props: {
    token: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([ 'isLoggedIn' ])
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    ...mapActions([ 'changeSession' ]),
    gotoHive() {
      console.log('goto', this.token)
      if (this.token.meta.tenant) {
        console.log('!!!! Should process token')
        this.changeSession(this.token.meta.tenant)
      }
    }
  }
}
</script>
